import React, { useEffect } from 'react';

import { Coords, ElementSize, Page } from 'editor/src/store/design/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import { CanvasRotation } from 'editor/src/component/EditorArea/types';

import { markDesignDataAsTouchedAction as markDesignDataAsTouchedOperation } from '../../../store/design/slice';

import EmptyContentPlaceholderDiscoverable from './EmptyContentPlaceholderDiscoverable';
import EmptyContentPlaceholderLegacy from './EmptyContentPlaceholderLegacy';

interface Props {
  spreadCoords: Coords;
  content: ElementSize;
  canvasRotation: CanvasRotation;
  page: Page;
}

function EmptyContentPlaceholder({ spreadCoords, content, canvasRotation, page }: Props) {
  const enableGraphicStudioDiscovery = useSelector((state) => state.hostSettings.enableGraphicStudioDiscovery);
  const dispatch = useDispatch();

  useEffect(() => {
    if (page?.groups.media?.length) {
      dispatch(markDesignDataAsTouchedOperation());
    }
  }, [page?.groups.media?.length]);

  return enableGraphicStudioDiscovery ? (
    <EmptyContentPlaceholderDiscoverable
      spreadCoords={spreadCoords}
      content={content}
      canvasRotation={canvasRotation}
      page={page}
    />
  ) : (
    <EmptyContentPlaceholderLegacy
      spreadCoords={spreadCoords}
      content={content}
      canvasRotation={canvasRotation}
      page={page}
    />
  );
}

export default React.memo(EmptyContentPlaceholder);
